import { render } from "./browse.vue?vue&type=template&id=29b1d686&scoped=true&ts=true"
import script from "./browse.vue?vue&type=script&setup=true&lang=ts"
export * from "./browse.vue?vue&type=script&setup=true&lang=ts"

import "./browse.vue?vue&type=style&index=0&id=29b1d686&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29b1d686"],['__file',"src/layout/browse.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "29b1d686"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('29b1d686', __exports__)) {
    console.log('reload')
    api.reload('29b1d686', __exports__)
  }
  
  module.hot.accept("./browse.vue?vue&type=template&id=29b1d686&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('29b1d686', render)
  })

}


export default __exports__